/*
 * r16p review T1 (2026-10-24): every chat and API-key query key carries the signed-in ACCOUNT. App.js keeps one module-level
 * QueryClient for the whole tab and signing out is an SPA navigate, so a key without the account let account 8 see account 7's
 * cached conversation rows (names, previews) and counts until 8's own requests answered - or for good when 8's list request failed.
 *
 *   ['chats', owner, 'info' | 'summary' | 'threads' | 'thread', ...]   ['api-keys', owner]
 *
 * The first element stays 'chats' / 'api-keys' so one removeQueries({ queryKey: ['chats'] }) drops every account's chat data
 * (components/ChatsCacheGuard.js does that on sign-out and on any account change). `owner` is the same string the reply drafts are
 * keyed by (lib/chatDraft.js). It is never logged and never put in a URL.
 */

/** The account a cache entry belongs to: `u<id>`, else the e-mail, else 'signed-out'. */
export function chatsOwner(user) {
  if (!user || typeof user !== 'object') return 'signed-out';
  if (user.id !== undefined && user.id !== null && String(user.id) !== '') return `u${user.id}`;
  if (typeof user.email === 'string' && user.email) return `e:${user.email}`;
  return 'me';
}

export const CHATS_ROOT = ['chats'];
export const API_KEYS_ROOT = ['api-keys'];

export const chatsKeys = {
  all: (owner) => ['chats', owner],
  info: (owner) => ['chats', owner, 'info'],
  summary: (owner) => ['chats', owner, 'summary'],
  threads: (owner) => ['chats', owner, 'threads'],
  threadList: (owner, slot, filter) => ['chats', owner, 'threads', slot || '*', filter],
  thread: (owner, id) => ['chats', owner, 'thread', id],
  // r16pm: the account's chat settings (retention); under the 'chats' root, so ChatsCacheGuard drops it with the rest
  settings: (owner) => ['chats', owner, 'settings'],
  apiKeys: (owner) => ['api-keys', owner],
};

/**
 * A placeholderData function that keeps the previous answer on screen ONLY while it belongs to the same account (a key change from
 * one filter to another keeps the old rows dimmed; a change of account never carries one account's rows into another's).
 */
export function keepPreviousForOwner(owner) {
  return (prev, prevQuery) => {
    if (prev === undefined || !prevQuery || !Array.isArray(prevQuery.queryKey)) return undefined;
    return prevQuery.queryKey[1] === owner ? prev : undefined;
  };
}
